// Geometry for the home widget visuals (HOME_WIDGETS_SPEC.md §2 "Mini
// visual"). Pure functions: the slot components call them through `el.call`
// (a component file may not import a sibling), and the tests call them
// directly.

// Sparkline geometry in a `w` × `h` viewBox with `pad` px of inset: the
// stroke path, the closed area path under it, and the last point (the end
// marker). Values are scaled to the series' own min..max; a flat series sits
// on the middle line. Fewer than two points draw nothing — the slot shows its
// skeleton instead of a lone dot. Coordinates are rounded to 0.1 px so the
// path text stays short and stable between renders.
export const homeSparkGeom = function homeSparkGeom(points, w, h, pad) {
  const values = Array.isArray(points)
    ? points.map(Number).filter((v) => Number.isFinite(v))
    : []
  if (values.length < 2) return null
  const width = Number(w) || 120
  const height = Number(h) || 36
  const inset = Number(pad) >= 0 ? Number(pad) : 3
  const min = Math.min(...values)
  const max = Math.max(...values)
  const span = max - min
  const round = (n) => Math.round(n * 10) / 10
  const step = (width - inset * 2) / (values.length - 1)
  const coords = values.map((v, i) => ({
    x: round(inset + i * step),
    y: round(span ? height - inset - ((v - min) / span) * (height - inset * 2) : height / 2)
  }))
  const line = coords.map((p, i) => `${i ? 'L' : 'M'}${p.x},${p.y}`).join(' ')
  const first = coords[0]
  const last = coords[coords.length - 1]
  return {
    linePath: line,
    areaPath: `${line} L${last.x},${height} L${first.x},${height} Z`,
    end: { x: last.x, y: last.y }
  }
}

// The CURRENT text of a slot element. A body declares `text` either as a
// string (a `{{ key | polyglot }}` template resolves in place) or as an
// `(el, s)` factory — and smbls keeps a factory AS the function on the
// element (element/src/create.js, the text effect), so reading `el.text`
// alone would see a function where the slot needs the value. Called from
// inside a slot's own reactive prop, the factory's state reads subscribe that
// prop too, so a skeleton hides the moment the number lands.
export const homeSlotText = function homeSlotText(target) {
  if (!target) return undefined
  const t = target.text
  if (typeof t !== 'function') return t
  try {
    return t(target, target.state, target.context)
  } catch (_) {
    return undefined
  }
}
